import type { MenuProps } from '@mui/material'
import { Paper, Portal } from '@mui/material'
import { TasksList } from './TasksList'

export type TasksPopoverProps = {
	open: MenuProps['open']
	position?: 'left' | 'bottom'
	anchorEl?: HTMLDivElement | null
}

export function TasksPopover({
	open,
	position = 'bottom',
	anchorEl,
}: TasksPopoverProps) {
	const { bottom, right } = anchorEl?.getBoundingClientRect() ?? {}
	const { height } = document.body.getBoundingClientRect()

	return (
		<Portal>
			<Paper
				elevation={5}
				sx={
					open
						? {
								display: 'block',
								position: 'absolute',
								bottom: position === 'left' ? height - (bottom ?? 0) : 64,
								...(position === 'bottom' ? { right: 40 } : { left: right }),
								zIndex: 9,
							}
						: { display: 'none' }
				}
			>
				<TasksList />
			</Paper>
		</Portal>
	)
}
